/**
 * utilWrapper.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 데스크탑 브랜드&분양페이지 Header 영역에서 우측 메뉴(개인정보, e편한세상 찾기)에 대한 렌더링 컴포넌트
 *
 * -----------------------------------------------------------------------------------------------
 */

import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
import { RoutesString } from 'common-modules/general/Config/routesString';
import MobxStore from 'common-modules/general/Store/MobxStore';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ClickAwayListener } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import RedirectHelper from 'common-modules/general/Model/RedirectHelper';

import { administrator } from 'common-modules/general/Config/constants';

interface StyleType {
  block?: Boolean;
}

const UtilMenuWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 1.875rem;
  right: 3.25rem;
  &.on {
    span {
      color: #666;
    }
  }
`;

const Text = styled.span`
  font-size: 0.875rem;
  font-family: 'SDGothicNeobTTF-bLt';
  color: #fff;
`;

const MyPageArea = styled.div`
  position: relative;
  display: inline-block;
  margin-left: 1.0625rem;
`;

const MyAreaBtn = styled.button`
  padding: 0;
  line-height: 1.15;
  margin-left: 0;
  cursor: pointer;
  &.on {
    span {
      color: #ff671d;
    }
    i {
      /* background-image: url(${GetStyledCompImg('common/bu_mypage_orange.png')}); */
      transform: rotate(-180deg);
      transition: all 0.3s;
      position: relative;
      top: -1px;
    }
  }

  &:hover,
  &:focus,
  &:active {
    span {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      color: #ff671d;
    }
    i {
      position: relative;
      background-image: url(${GetStyledCompImg('common/bu_mypage_orange.png')});
    }
  }
`;

const MyAreaList = styled.div`
  display: ${(props: StyleType) => (props.block ? 'block' : 'none')};
  position: absolute;
  white-space: nowrap;
  top: calc(100% + 8px);
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 0.4375rem 0 0.4375rem 0;
  border-radius: 10px;
  box-sizing: border-box;
  min-width: 7.5rem;
  box-shadow: 15px 15px 25px 0 rgba(0, 0, 0, 0.1);
`;
const LinkText = styled.a`
  display: block;
  color: #666 !important;
  padding: 0.5625rem 0.9375rem 0.4375rem;
  font-size: 0.875rem !important;
  transition: color 0.3s, background-color 0.3s;
  cursor: pointer;
  &:focus,
  &:hover {
    color: #ff671d;
    background: #f7f7f7;
  }
`;

const LinkA = styled(Link)`
  display: block;
  color: #666 !important;
  padding: 0.5625rem 0.9375rem 0.4375rem;
  font-size: 0.875rem !important;
  transition: color 0.3s, background-color 0.3s;
  cursor: pointer;
  &:focus,
  &:hover {
    color: #ff671d;
    background: #f7f7f7;
  }
`;

const HeaderButton = styled.a`
  display: inline-block;
  vertical-align: top;
  margin-left: 17px;
  margin-left: 1.0625rem;
  &:hover,
  &:active,
  &:focus {
    span {
      transition: color 0.3s ease, border 0.3s ease, background-color 0.3s;
      color: #ff671d;
    }
  }
`;

const Icon = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 0.5625rem;
  height: 0.3125rem;
  margin-left: 0.3125rem;
  background: url(${GetStyledCompImg('common/bu_mypage_white.png')});
  top: -1px;
`;

const UtilWrapper = observer((props: any) => {
  const {
    authManager: { userData, initAuthData },
    userAccess
  } = MobxStore();

  const history = useHistory();

  const redirectHelper = new RedirectHelper();

  userData?.idMbrOside && administrator.includes(userData.idMbrOside)
    ? userAccess.setAdminIdTp('ADMIN')
    : userAccess.initAdminIdTp();

  const isMain = process.env.REACT_APP_IS_BRAND;

  const handleClickLoginButton = () => {
    if (!props.isMain) {
      if (!userData) {
        const isDiffOrigin = RoutesString.Login.includes('http');
        const path = isDiffOrigin ? window.location.href : history.location.pathname;

        redirectHelper.setPageRedirectData(path, isDiffOrigin ? 'diff' : 'same-origin');
        window.location.href = RoutesString.Login;

        return;
      }
    }
  };

  return (
    <UtilMenuWrapper className={`header-util ${props.isMenuOpen ? 'on' : ''}`}>
      {props.isLogin ? (
        isMain ? (
          <ClickAwayListener onClickAway={() => props.setMyMenuOpen(false)}>
            <MyPageArea className="header-mypage-area">
              <MyAreaBtn
                className={props.menuOpen ? 'on' : ''}
                type="button"
                onClick={() => props.setMyMenuOpen(!props.menuOpen)}>
                <Text>{userData?.nmMbrActl}</Text>
                <Icon aria-hidden="true"></Icon>
              </MyAreaBtn>
              <MyAreaList block={props.menuOpen}>
                {userAccess.adminIdTp == 'ADMIN' && <LinkA to={RoutesString.MyPage}>*계약정보 확인*</LinkA>}
                <LinkA to={RoutesString.ChangeInfo}>개인정보 변경</LinkA>
                <LinkA to={RoutesString.ContractInfoChange}>계약정보 변경</LinkA>
                <LinkA to={RoutesString.ChangePW}>비밀번호 변경</LinkA>
                <LinkA to={RoutesString.IntersetComplex}>관심단지</LinkA>
                <LinkText onClick={() => initAuthData(true)}>로그아웃</LinkText>
              </MyAreaList>
            </MyPageArea>
          </ClickAwayListener>
        ) : (
          <ClickAwayListener onClickAway={() => props.setMyMenuOpen(false)}>
            <MyPageArea className="header-mypage-area">
              <MyAreaBtn
                className={props.menuOpen ? 'on' : ''}
                type="button"
                onClick={() => props.setMyMenuOpen(!props.menuOpen)}>
                <Text>{userData?.nmMbrActl}</Text>
                <Icon aria-hidden="true"></Icon>
              </MyAreaBtn>
              <MyAreaList block={props.menuOpen}>
                {userAccess.adminIdTp == 'ADMIN' && <LinkText href={RoutesString.MyPage}>*계약정보 확인*</LinkText>}
                <LinkText href={RoutesString.ChangeInfo}>개인정보 변경</LinkText>
                <LinkText href={RoutesString.ContractInfoChange}>계약정보 변경</LinkText>
                <LinkText href={RoutesString.ChangePW}>비밀번호 변경</LinkText>
                <LinkText href={RoutesString.IntersetComplex}>관심단지</LinkText>
                <LinkText onClick={() => initAuthData(true)}>로그아웃</LinkText>
              </MyAreaList>
            </MyPageArea>
          </ClickAwayListener>
        )
      ) : (
        <HeaderButton onClick={handleClickLoginButton} href={RoutesString.Login}>
          <Text>로그인</Text>
        </HeaderButton>
      )}

      <HeaderButton href={RoutesString.FooterFoundList}>
        <Text>e편한세상 찾기</Text>
      </HeaderButton>
    </UtilMenuWrapper>
  );
});

export default UtilWrapper;
